import { Component, OnInit } from '@angular/core';
import { NbDialogService, NbToastrService } from '@nebular/theme';
import { ApiService } from '../../shared/api.service';
import { EventSendeurService } from '../../shared/event-sendeur.service';
import { EditEcoleComponent } from './edit-ecole/edit-ecole.component';
import { ServerDataSource, LocalDataSource } from 'ng2-smart-table';
import { Router } from '@angular/router';
import { Page } from '../../shared/data/page';
import { plainToClass } from 'class-transformer';
import { PublishRenderComponent } from '../projet/publish-render.component';
import swal from 'sweetalert2';
import { Ecole } from '../../shared/data/ecole';

@Component({
  selector: 'ngx-listecole',
  templateUrl: './listecole.component.html',
  styleUrls: ['./listecole.component.scss']
})
export class ListEcoleComponent implements OnInit {


  constructor(private dialogService: NbDialogService,private apiService:ApiService, private sendeurService:EventSendeurService, private router:Router, private toastr:NbToastrService) { }

  ngOnInit() {


    this.getEcole();

    this.sendeurService.ecoleEvent.subscribe(data =>{
      this.getEcole();
    })


  }

 

  source: LocalDataSource =  new LocalDataSource();
  settings = {

    // hideSubHeader: true,
    mode: 'external',
    actions: {
      columnTitle: '',
      position: 'left',
      add: true,
      edit: true,
      delete: true,
    },
    add: {
      addButtonContent: '<i class="nb-plus"></i>',
      confirmCreate: false,
    },
    edit: {
      editButtonContent: '<i class="nb-edit"></i>',
      saveButtonContent: '<i class="nb-checkmark"></i>',
      cancelButtonContent: '<i class="nb-close"></i>',
      confirmSave:false
    },
    delete: {
      deleteButtonContent: '<i class="nb-trash"></i>',
      confirmDelete: true,
    },
  columns: {
    id: {
      title: 'ID',
      type: 'number',
      filter: false,
    },
    /* slug: {
      title: 'Slug',
      type: 'string',
    }, */
    urltmbPhoto: {
      title: 'Logo',
      type: 'html',
      valuePrepareFunction: (photo:string) => { return `<img  src="${photo}" height="50px" width="50px" />`; },
      filter: false
    },
    titre: {
      title: 'Nom',
      type: 'string',
    },
    promoteur: {
      title: 'Promoteur',
      type: 'string',
    },
    labelpays: {
      title: 'Pays',
      type: 'string',
    },
    adresse: {
      title: 'Adresse',
      type: 'string',
    },
    is_publish: {
      title: '',
      type: 'custom',
      renderComponent: PublishRenderComponent, // ne pas oublier de déclarer dans le module et d'ajouter dans l'entré entryComponents
      filter: false,
    },

   
  },
  pager : {
    perPage :10
  },
 
};



  

  select($event){
    const closeOnBackdropClick = false;
    this.dialogService.open(EditEcoleComponent,{closeOnBackdropClick, context:{id:$event.data.id}});
  }

  onDelete(event){
    // this.dialogService.open(DeletePageComponent,{context:{id:$event.data.id}});
    const ecole = plainToClass( Ecole,  event.data as object);
    
    swal({
      title: 'Suppression ecole',
      text: 'Voulez - vous vraiment supprimer ' + ecole.titre + ' ? Vous ne pourrez plus annuler cet opération',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Annuler',
      confirmButtonText: 'Confirmer',
      showLoaderOnConfirm: true,
      allowOutsideClick: false,
      preConfirm: () => {

        // this.dialogIsNotShow = true;

        return this.apiService.deleteEcoleProvider(ecole.id).subscribe(data =>{
          
          // console.log(data);
          this.source.remove(event.data);
          this.toastr.success("Supprimé(e)", ecole.titre);
         
        },(err) =>{
          this.toastr.danger("Echec de suppréssion ");
          if(err.error.code ===401){
            localStorage.clear();
            window.location.reload();
            let link2 = ['/login'];
            this.router.navigate(link2);
          }
    
          if(err.error.code ===500){
          
            this.toastr.danger("Le serveur est actuellement indisponible, veuillez patienter ou actualiser la page");
         }
        })

      },
    }).then((result) => {

      if (result.value) {


        /* this.toastr.success("Supprimé(e)", ecole.titre); */

      }

      // this.dialogIsNotShow = false;

    });


  
  }

  
  onCreate(event){

    const closeOnBackdropClick = false;
    this.dialogService.open(EditEcoleComponent,{closeOnBackdropClick, context:{id:0}});
  }


  getEcole(){

    this.apiService.getAllEcoleProvider('').subscribe(data =>{

      this.source.load(  plainToClass( Ecole, data) );
      // this.pages = plainToClass( Page, data);
      this.source.setSort([{ field: 'id', direction: 'desc' }]);

    },(err) =>{

      if(err.error.code ===401){
        localStorage.clear();
        window.location.reload();
        let link2 = ['/login'];
        this.router.navigate(link2);
      }

      if(err.error.code ===500){
      
        this.toastr.danger("Le serveur est actuellement indisponible, veuillez patienter ou actualiser la page");
      }
    
    })
  }

}
